// @flow
// @jsx h
import { h, Component } from "preact";
import { Text, IntlProvider } from "preact-i18n";

import styles from "./FormInput.scss";
import { withStyles } from "elc-theme";
import { GlassIcon } from "elc-icons";
import SwitchInput from "./SwitchInput";
import InputError from "./InputError";
//liste ds pays
import { COUNTRIES } from "elc-commons";

import { en, fr, de, nl, it, es, ca } from "./translations";


class AutocompleteAddress extends Component {

  constructor(props) {
    super(props);
    this.state = {
      address: props.value
        ? props.value
        : {
            street_number: "",
            route: "",
            locality: "",
            // administrative_area_level_1: '',
            country: "",
            postal_code: "",
            code_pays:""
          },
      visible:
        props.clientFormField.mandatory || props.isClientInformationMandatory
          ? true
          : false,
      error : props.error
    };
  }

  onChange = ({ target }) => {
    let value = target.value;

    this.setState(prevState => {
      
    if(target.id === "country"){
        const codePays = target.value;
        const paysLabel = COUNTRIES.find((country) => country.code === codePays);
        value = paysLabel?.name[this.props.locale]
        prevState.address.code_pays = target.value;
    }

      prevState.address[target.id] = value;

      this.props.onAddressChange(prevState.address);
      return { address: prevState.address };
    });
  };

  onBlur = ({ target }) => {
    if(this.props.onAddressBlur){
        let value = target.value;

        this.setState(prevState => {
          
        if(target.id === "country"){
            const codePays = target.value;
            const paysLabel = COUNTRIES.find((country) => country.code === codePays);
            value = paysLabel?.name[this.props.locale]
            prevState.address.code_pays = target.value;
        }

          prevState.address[target.id] = value;

          this.props.onAddressBlur(prevState.address);
          return { address: prevState.address };
        });
    }
  };


  isMandatory = () =>
    this.props.clientFormField.mandatory ||
    this.props.isClientInformationMandatory
      ? true
      : false;

  componentDidMount() {

  }

componentDidUpdate(prevProps) {
  if (JSON.stringify(prevProps.value) !== JSON.stringify(this.props.value)) {
    this.setState({ address: this.props.value });
  }

  if (prevProps.error !== this.props.error) {
    this.setState({ error: this.props.error });
  }
}


  onToggleAddressVisibility = () => {
    this.setState(prevState => ({
      visible: !prevState.visible
    }));
  };
  /* eslint-disable */
  render(
    { clientFormField, getClassName, locale },
    { address, visible ,error},
    context
  ) {
  let localeDefinition = "";

  switch (locale) {
    case "fr":
      localeDefinition = fr;
      break;
    case "en":
      localeDefinition = en;
      break;
    case "de":
      localeDefinition = de;
      break;
    case "nl":
      localeDefinition = nl;
      break;
    case "it":
      localeDefinition = it;
      break;
    case "es":
      localeDefinition = es;
      break;
    case "ca":
      localeDefinition = ca;
      break;
    default:
      localeDefinition = fr;
  }
    return (
      <IntlProvider definition={localeDefinition}>
      <div>
        <div
          key={clientFormField.id}
          class={getClassName("inputField", "inputFieldCheckbox")}
        >
          <div class={getClassName("switchInput")}>
            {!this.isMandatory() && (
              <SwitchInput
                name={clientFormField._embedded.clientFormInputType.label}
                id={clientFormField.id}
                value={visible ? "1" : "0"}
                onChange={this.onToggleAddressVisibility}
              />
            )}
            <label class={getClassName("label")} htmlFor={clientFormField.id}>
              {clientFormField._embedded.clientFormInputType.label}
              {this.isMandatory() && (
                <span class={getClassName("requiredSign")}>*</span>
              )}{" "}
            </label>
          </div>
        </div>
        <div
          class={getClassName("autoCompleteAddressFields", {
            invisible: !visible
          })}
        >         
          <div>
            <div class={getClassName("inputField", "column")}>
              <div
                class={
                  context.theme && context.theme.label
                    ? context.theme.label
                    : styles.label
                }
              >
                <Text id="address.streetAddress">Street address</Text>
                {this.isMandatory() && (
                  <span class={getClassName("requiredSign")}>*</span>
                )}
              </div>
              <div class={styles.row}>
                <div class={styles.streetNumber}>
                  <input
                    class={styles.input}
                    id="street_number"
                    value={address.street_number}
                    placeholder="N°"
                    onChange={this.onChange}
                    onBlur={this.onBlur}
                  />
                </div>
                <div>
                  <input
                    class={styles.input}
                    id="route"
                    value={address.route}
                    placeholder="rue, lieu-dit"
                    autoComplete="street-address"
                    onChange={this.onChange}
                    onBlur={this.onBlur}
                  />
                </div>
              </div>
              {error &&
                (error.fields.includes("route") || error.fields.includes("street_number")) && (
                  <div class={styles.row}>
                    <InputError error={error} />
                  </div>
                )}
            </div>
            <div class={styles.row}>
              <div class={getClassName("inputField", "column", "zipCode")}>
                <div
                  class={
                    context.theme && context.theme.label
                      ? context.theme.label
                      : styles.label
                  }
                >
                  <Text id="address.zipCode">Zip code</Text>
                  {this.isMandatory() && (
                    <span class={getClassName("requiredSign")}>*</span>
                  )}
                </div>
                <div>
                  <input
                    class={styles.input}
                    id="postal_code"
                    value={address.postal_code}
                    autoComplete="postal-code"
                    onChange={this.onChange}
                    onBlur={this.onBlur}
                  />
                  {error &&
                    error.fields.includes("postal_code") && (
                      <InputError error={error} />
                    )}
                </div>
              </div>
              <div class={getClassName("inputField", "column", "city")}>
                <div
                  class={
                    context.theme && context.theme.label
                      ? context.theme.label
                      : styles.label
                  }
                >
                  <Text id="address.city">City</Text>
                  {this.isMandatory() && (
                    <span class={getClassName("requiredSign")}>*</span>
                  )}
                </div>
                <div>
                  <input
                    class={styles.input}
                    id="locality"
                    value={address.locality}
                    onChange={this.onChange}
                    onBlur={this.onBlur}
                  />
                  {error &&
                    error.fields.includes("locality") && (
                      <InputError error={error} />
                    )}
                </div>
              </div>
            </div>
            {/* <div class={styles.row}>
              <div
                class={
                  context.theme && context.theme.label
                    ? context.theme.label
                    : styles.label
                }
              >
                State
              </div>
              <div>
                <input
                  class={styles.input}
                  id="administrative_area_level_1"
                  value={address.administrative_area_level_1}
                />
              </div>
            </div> */}
            <div class={styles.column}>
              <div
                class={
                  context.theme && context.theme.label
                    ? context.theme.label
                    : styles.label
                }
              >
                <Text id="address.country">Country</Text>
                {this.isMandatory() && (
                  <span class={getClassName("requiredSign")}>*</span>
                )}
              </div>
              <div>
                 {/* <input
                  class={styles.input}
                  
                  value={address.country}
                  autoComplete="country"
                  onChange={this.onChange}
                />  */}
                <div class={styles.selectWrapper}>
                  <select
                    id="country"
                    class={getClassName("select")}
                    value={address.code_pays}
                    onInput={this.onChange}
                    onBlur={this.onBlur}
                  >
                    {COUNTRIES.map((c) => (
                      <option key={c.code} value={c.code}>
                        {c.name[locale] || c.name["fr"]}
                      </option>
                    ))}
                  </select>
                </div>
                {error &&
                  error.fields.includes("country") && (
                    <InputError error={error} />
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
      </IntlProvider>
    );
  }
}
/* eslint-enable */
export default withStyles(AutocompleteAddress, styles) //withScriptjs(withStyles(AutocompleteAddress, styles));
